import styled from "styled-components";

import { useHasFeature } from "@hooks";

export const FooterContainer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--global-background-color);
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.13);
  text-align: center;
  font-size: var(--global-font-size-xs);
  font-weight: var(--global-font-weight-regular);
  color: #606368;
  z-index: 10;

  & a:not(:first-child)::before {
    content: " - ";
    display: inline-block;
  }
`;

export const Footer: React.FC<any> = () => {
  const hasNonStandardTOC = useHasFeature("hasNonStandardTOC");
  return (
    <FooterContainer>
      <a href="/pricing" target="_blank" rel="noopener noreferrer">
        Pricing
      </a>
      {!hasNonStandardTOC && (
        <a
          href="https://semgrep.dev/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>
      )}
      <a
        href="https://semgrep.dev/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy policy
      </a>
      <a
        href="https://status.semgrep.dev/"
        target="_blank"
        rel="noopener noreferrer"
      >
        App status
      </a>
    </FooterContainer>
  );
};
